import { render, staticRenderFns } from "./listartikel.vue?vue&type=template&id=0fd15684&"
import script from "./listartikel.vue?vue&type=script&lang=js&"
export * from "./listartikel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports